<div class="container">
  <div class="modalHeader">
    <div class="d-flex justify-content-end mt-1">
      <app-dialog-button></app-dialog-button>
    </div>

    <div class="title-modal-mat">Recortar Imagem</div>
    <p class="banner-crop-sub">{{ descricao }}</p>
  </div>

  <div mat-dialog-content>
    <div class="banner-crop-area">
      <span class="banner-crop-badge">
        Proporção padrão: {{ larguraBanner }} × {{ alturaBanner }}px
      </span>

      <image-cropper
        [imageFile]="arquivo"
        [maintainAspectRatio]="true"
        [aspectRatio]="proporcaoBanner"
        [transform]="transform"
        [containWithinAspectRatio]="false"
        output="base64"
        format="png"
        (imageCropped)="onImageCropped($event)">
      </image-cropper>
    </div>

    <div class="banner-crop-zoom">
      <button type="button" class="banner-crop-zoom-btn" (click)="diminuirZoom()" aria-label="Diminuir zoom">
        <i-lucide name="minus" size="18"></i-lucide>
      </button>

      <input
        type="range"
        class="banner-crop-slider"
        [min]="zoomMin"
        [max]="zoomMax"
        [step]="zoomPasso"
        [value]="zoom"
        (input)="onZoomChange($any($event.target).valueAsNumber)">

      <button type="button" class="banner-crop-zoom-btn" (click)="aumentarZoom()" aria-label="Aumentar zoom">
        <i-lucide name="plus" size="18"></i-lucide>
      </button>
    </div>

    <div class="d-flex justify-content-end mb-3 gap-2">
      <button type="button" class="btn btn-cancelar-modal" mat-dialog-close>
        Voltar
      </button>
      <button type="button" class="btn btn-import" (click)="confirmar()">
        Confirmar Recorte
      </button>
    </div>
  </div>
</div>
